import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { TableHeaderInterfaceModel } from '../../../models/table.model';

@Component({
  selector: 'app-card-header-navigation',
  templateUrl: './card-header-navigation.component.html',
  styleUrls: ['./card-header-navigation.component.scss'],
  standalone: false,
})
export class CardHeaderNavigationComponent implements OnInit {
  @Input() card: TableHeaderInterfaceModel;
  @Output() onCardClick = new EventEmitter<void>();
  public ngOnInit() {
    if (this.card === undefined) {
      this.card = {
        class: 'default',
        title: 'Placeholder Title',
        details: 'Placeholder Details',
      };
    }
  }

  public onClick() {
    this.onCardClick.emit();
  }

  isDetailsObservable(details: any): details is Observable<any> {
    return details instanceof Observable;
  }
}
